/***
 * 拆分核心业务请求 和 非核心业务请求
 * 核心业务请求在Service1(index)里 非核心业务请求在Service2里
 * 2022-06-20 CHP
 */
import axios from 'axios'
// import store from '@/store/store'
// import router from '@/router'
import config from '../../static/config/config'
import {getErrorMessage, shouldLogout, canRefresh} from '@/constant/errorCode'

// 2021/11/23 WXJ   增加计数器
let requestNumber = 0

// Token 刷新相关
let isRefreshing = false
let refreshSubscribers = []

// 检查 token 是否需要刷新（已过期或 1 分钟内过期）
function needsRefresh (token) {
  if (!token) return false
  const jwt = parseJWT(token)
  if (!jwt || !jwt.exp) return false
  const now = Math.floor(Date.now() / 1000)
  const buffer = 60 // 1 分钟缓冲
  return jwt.exp - now < buffer
}

// 登出操作：清除 token 并跳转登录页
function doLogout (reason) {
  console.log(reason)
  // localStorage.removeItem('LHP')
  // localStorage.removeItem('userInfo')
  // window.location.href = '/Login'
  // return Promise.reject(new Error(reason))
}

// 刷新 token（后端从 HttpOnly Cookie 读取 refreshToken）
function refreshToken () {
  return new Promise((resolve, reject) => {
    const send = axios.create({
      baseURL: config.baseURL,
      withCredentials: true // 跨域携带 cookie
    })
    // 后端只读 HttpOnly Cookie，不需要传 Authorization
    send.post('/api/account/refreshToken')
      .then(res => {
        res = res.data
        if (res.data && res.code === 200 && res.data.token) {
          localStorage.setItem('LHP', res.data.token)
          resolve(res.data.token)
        } else {
          reject(new Error('Refresh failed'))
        }
      })
      .catch(reject)
  })
}

// 将等待的请求加入队列
function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb)
}

// 通知队列中的请求可以继续
function onRefreshed (newToken) {
  refreshSubscribers.forEach(cb => cb(newToken))
  refreshSubscribers = []
}

const request = (method, url, data, noLoading) => {
  // !noLoading && store.commit('toggleLoading', true)
  // console.log('noLoading::' + noLoading + '::' + url)
  if (!noLoading) {
    document.getElementById('loading').style.display = 'block'
  }
  const send = axios.create({
    baseURL: config.baseURL,
    withCredentials: true // 跨域携带 cookie，后端 Set-Cookie 才能生效
  })
  send.interceptors.request.use(async config => {
    // 2021/11/23 WXJ   增加计数器
    if (!noLoading) {
      requestNumber++
    }

    // console.log('requestNumber++：' + requestNumber)

    let token = localStorage.getItem('userInfo') ? localStorage.getItem('LHP') : ''

    // 检查 token 是否需要刷新（提前 1 分钟预判）
    if (token && needsRefresh(token)) {
      if (!isRefreshing) {
        isRefreshing = true
        try {
          token = await refreshToken()
          isRefreshing = false
          onRefreshed(token)
        } catch (err) {
          isRefreshing = false
          refreshSubscribers = []
          // 刷新失败（可能是网络问题），用原 token 继续请求
          // 让后端返回 -103/-104 时由响应拦截器处理
          console.warn('Token refresh failed, proceeding with old token:', err.message)
        }
      } else {
        // 正在刷新，等待完成后继续
        return new Promise((resolve) => {
          subscribeTokenRefresh((newToken) => {
            config.headers.Authorization = newToken
            resolve(config)
          })
        })
      }
    }

    config.headers.Authorization = token
    return config
  }, err => {
    return Promise.reject(err)
  })

  send.interceptors.response.use(response => {
    // 2021/11/23 WXJ   增加计数器
    if (!noLoading) {
      requestNumber--
    }
    // 2021/11/23 WXJ   根据计数器显示
    if (requestNumber <= 0) {
      document.getElementById('loading').style.display = 'none'
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo) {
      // 检查响应头中是否有新 token，有则更新到 LHP
      const newToken = response.headers['X-New-Token']
      if (newToken) {
        localStorage.setItem('LHP', newToken)
        // 同步更新 userInfo 中的 token（如果需要）
        userInfo.token = newToken
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      }
    }

    // 根据后端 ErrorCode 枚举处理业务错误码
    if (response.data) {
      const code = response.data.code
      // Token 过期（-103），尝试刷新并重试原请求
      if (canRefresh(code)) {
        // 保存原始请求配置用于重试
        const originalRequest = response.config
        if (!isRefreshing) {
          isRefreshing = true
          return refreshToken()
            .then(newToken => {
              isRefreshing = false
              // 更新原始请求的 token
              originalRequest.headers.Authorization = newToken
              // 通知队列中的其他请求
              onRefreshed(newToken)
              // 重试原始请求
              return send(originalRequest)
            })
            .catch(() => {
              isRefreshing = false
              refreshSubscribers = []
              return doLogout('Token refresh failed, code: ' + code)
            })
        }
        // 其他并发请求加入等待队列，刷新完成后自动重试
        return new Promise((resolve) => {
          subscribeTokenRefresh((newToken) => {
            originalRequest.headers.Authorization = newToken
            resolve(send(originalRequest))
          })
        })
      }
      // 需要登出的错误码（TOKEN_INVALID / INVALID_USER）
      if (shouldLogout(code)) {
        return doLogout(getErrorMessage(code) + ', code: ' + code)
      }
    }

    return response.data
  }, error => {
    if (!noLoading) {
      requestNumber--
    }
    // console.log('error requestNumber--：' + requestNumber)
    if (requestNumber <= 0) {
      document.getElementById('loading').style.display = 'none'
    }
    // 2021-06-19 CHEN PU If err.response is null, here will throw exception
    if (error.response && error.response.status === 401) {
      // router.push('/Login')
    }
    return Promise.reject(error.response) // 返回接口返回的错误信息
  })

  return send({method, url, data})
}

function parseJWT (token) {
  try {
    const payload = token.split('.')[1]
    const decoded = atob(payload)
    return JSON.parse(decoded)
  } catch (e) {
    return null
  }
}

export default request



// WEBPACK FOOTER //
// ./src/service2/index.js